import styled from 'styled-components';
import { InputLabel } from '@mui/material';
import { theme } from '../../styles/theme';
export const Wrapper = styled(InputLabel) `
  && {
    ${theme.typography.label};
    color: ${theme.colors.text};
    margin-bottom: ${theme.spacing.xxs};
    position: static;
    transform: none;

    &.Mui-error {
      color: ${theme.colors.errorForeground};
    }

    &.Mui-focused {
      color: inherit;
      padding: 0;
    }
  }
`;
